/*global FB*/
import React from 'react'

import * as qs from 'query-string';
import TBCBackground from './TBCBackground'
import TBCMessage from './TBCMessage'
import TBCText from './TBCText'
import TBCOverlay from './TBCOverlay'
import Cookies from 'js-cookie'

export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      cur_message: 0,
      storyboard_items: [],
      is_message_stacked: true,
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (!this.props.is_active && nextProps.is_active)
    {
      // resuming itself, disable expired overlays
      var items = this.state.storyboard_items || [];
      var cur_message = this.state.cur_message || 0;
      var is_message_stacked = this.state.is_message_stacked;
      if (is_message_stacked)
      {
        for (var k = 0; k < items.length && k < cur_message + 1; k++)
        {
          items[k].is_expired = true;
        }
      }
    }

    if (this.props.isTriggerRefresh && !nextProps.isTriggerRefresh)
    {
      if (global.DEBUG)
        console.log("XXXXX", this.props.isTriggerRefresh , nextProps.isTriggerRefresh)
      requestAnimationFrame(() => {
        this.state.cur_message = 0;
        this.state.item_bg_pos = 0;
        this.rebuildStoryboard_items()
      })
    }
  }

  componentDidMount()
  {
    this.rebuildStoryboard_items()
  }



  rebuildStoryboard_items()
  {
    if (global.DEBUG)
      console.log("ASDASDSA", this.props.scene);
    var scene = this.props.scene;

    if (typeof(scene.items) ==='undefined')  // old version may have empty scene
      var items = [];
    else
      var items = scene.items.item || [];
    var is_message_stacked = true;
    if (!Array.isArray(items))
    {
      items = [items];
      is_message_stacked = false;

      var meta = scene.meta;
      var meta_type = meta._attributes.type;
      var meta_style = meta._attributes.style;
      if (meta_type === 'content')
      {
        is_message_stacked = true;
      }
      if (meta_style === 'fullScreen')
      {
        is_message_stacked = false;
      }
    }

    var storyboard_items = [];
    for (var m in items)
    {
      var item = items[m];
      if (global.DEBUG)
        console.log("overlay?", item.overlay, item);
      if (item.overlay) {
        item.overlay.is_overlay = true;
        if (item.overlay._attributes.timing) {
          if (item.overlay._attributes.timing === 'after') {
            storyboard_items.push(item.overlay);
            storyboard_items.push(item);
          }
          else {
            storyboard_items.push(item.overlay);
            storyboard_items.push(item);
          }
        }
      }
      else
      {
        storyboard_items.push(item);
      }
    }
    this.setState({
      is_message_stacked: is_message_stacked,
      storyboard_items: storyboard_items,
    })
    if (global.DEBUG)
      console.log(storyboard_items);

    window.onscroll = () => {
      if(window.pageYOffset === 0) {
        this.prevScene();
      }
    };
    window.onpopstate = () =>{
      this.prevScene();
    };
  }



  componentWillUnmount() {
    window.onscroll = null;
    window.onpopstate = null;
  }



  nextScene(is_ended_callback)
  {
    this.props.nextScene(is_ended_callback);
  }

  prevScene()
  {
    this.props.prevScene();
  }
  scrollViewScroll()
  {
    //console.log(this.scrollView.scrollTop);
    if(this.scrollView.scrollTop === 0) {
      this.prevScene();
    }
  }

  nextMessage()
  {
    var scene = this.props.scene;
    var items = this.state.storyboard_items;
    var is_message_stacked = true;
    if (!Array.isArray(items))
    {
      items = [items];
      is_message_stacked = false;

      var meta = scene.meta;
      var meta_type = meta._attributes.type;
      if (meta_type === 'content')
      {
        is_message_stacked = true;
      }
    }
    if (global.DEBUG)
      console.log(this.state.cur_message, items.length);
    if (this.state.cur_message + 1 >= items.length)
    {
      this.nextScene(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.scrollView.scroll({top: this.scrollView.scrollHeight - this.scrollView.clientHeight, left: 0, behavior: 'smooth'});//  Top = this.scrollView.scrollHeight - this.scrollView.clientHeight;
          })
        })
      });
    }
    else
    {
      this.setState({cur_message: this.state.cur_message + 1}, () => {
        this.scrollView.scroll({top: this.scrollView.scrollHeight - this.scrollView.clientHeight, left: 0, behavior: 'smooth'});//  Top = this.scrollView.scrollHeight - this.scrollView.clientHeight;
      });
    }
    window.scrollV = this.scrollView;



    // POST PROCESSING ITEMS AT K

    var msg = items[this.state.cur_message];
    if (global.DEBUG)
      console.log("MSG: ", msg);
    // try to find / refresh BG
    for (var k = this.state.cur_message || 0; k >= 0; k--)
    {
      if (items.length > k)
      {
        var item = items[k];
        var item_bg = item.bg;
        if (item_bg)
        {
          if (this.state.item_bg_pos !== k)
          {
            this.setState({
              item_bg_pos: k,
            })
          }
          break;
        }
      }
    }
  }

  render() {
    var scene = this.props.scene;
    if (scene.meta){ // old version may have empty scene
      var meta = scene.meta;
      var meta_allowSkip = meta._attributes.allowSkip;
      var meta_anim = meta._attributes.anim;
      var meta_style = meta._attributes.style;
      var meta_type = meta._attributes.type;
      // console.log(scene)

      var message_position = 'relative';
      var overflow = 'scroll';
      if (meta_style === 'fullScreen')
      {
        message_position = 'absolute';
        overflow = 'hidden';
      }

      if (this.props.is_active)
      { 
        if (global.DEBUG){
          console.log('======');
          console.log("Scene: ", this.props);
        }
      }
      else
      {
        return null;
      }


      var items = this.state.storyboard_items || [];
      var is_message_stacked = this.state.is_message_stacked;
      var item_position = 'relative';
      if (!is_message_stacked)
      {
        item_position = 'absolute';
      }

      if (global.DEBUG){
        console.log("message_position: ", message_position);
        console.log("is_message_stacked: ", is_message_stacked);
      }

      return (
        <TBCBackground BG bg={Object.assign({_attributes: {
          color: '#000'
        }}, items[this.state.item_bg_pos || 0] && items[this.state.item_bg_pos || 0].bg )}>
          <div style={{position: `absolute`, margin: 0, padding: 0, left: 0, right: 0, bottom: 0, top: 0, display: this.props.is_active ? 'block' : 'none'}} onClick={() => {
            if (global.DEBUG){
              console.log("SS");            
            }
            this.nextMessage()
          }}>
            <div
              ref={(view) => {
                this.scrollView = view;
              }}
              onScroll={()=>{
                this.scrollViewScroll()
              }}
              style={{position: `absolute`, margin: 0, padding: 0, left: 0, right: 0, bottom: 0, top: 0, overflow: `scroll`}}>
              {
                (() => {
                  if (is_message_stacked)
                  {
                    return items.map((message, k) => {
                      if (k > this.state.cur_message)
                      {
                        return null;
                      }
                      if (message.is_overlay)
                      {
                        return (
                          <TBCOverlay
                            key={k}
                            is_expired={message.is_expired}
                            is_fullscreen={false}
                            is_modal={true}
                            nextMessage={() => {this.nextMessage()}}
                            item_position={'absolute'}
                            message={message}/>
                        )
                      }
                      else
                      {
                        return (
                          <TBCMessage
                            key={k}
                            item_position={item_position}
                            message={message}
                            text={message.text}/>
                        )
                      }
                    })
                  }
                  else
                  {
                    return items.map((message, k) => {
                      if (k > this.state.cur_message)
                      {
                        return null;
                      }
                      return (
                        <TBCOverlay
                          key={k}
                          is_fullscreen={true}
                          item_position={item_position}
                          message={message}/>
                      )
                    })
                  }
                })()
              }

              {
                this.props.is_ended ? (
                  <div style={{margin: 35, padding: 30, fontSize: 14, color: 'white', textAlign: `center`}}>
                    - {this.props.episodeName} 完 -<br></br>                  
                  </div>                                
                ) : null
              }
              {
                this.props.is_ended ? (
                  <div style={{float:'right',textAlign:'center',marginRight:"20px"}} onClick={() => {
                    const parsed = qs.parse(global.location.search);
                    
                    let hrefGet = window.location.href.replace(/http:\/\//g, '').replace(/https:\/\//g, '');
                    hrefGet = hrefGet.split(/\/*\//);
                    hrefGet.splice(0, 1);                    
                    var epsiodeUUID = hrefGet[3] || '';

                    var contentUrl = parsed.contentUrl || Cookies.get(epsiodeUUID+"-contentUrl");;

                    var directory = contentUrl.split("/").slice(3,-1).join("/")  //split to array & remove last element
                    var arr = directory.split("/");
                    

                    var url='https://tbcstory.com/?uuid='+arr[0]+'&episode='+arr[1];
                    
                    //window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURI(url), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false; 

                    FB.ui({
                      method: 'share',
                      href: url,
                    }, function(response){});
                  }}>
                    <img style={{width:'114px',height:'55px'}} src="data:image/png;base64,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"></img>
                  </div>
                ) : null
              }

              <div style={{height: 120}}>
              </div>

            </div>
          </div>
        </TBCBackground>
      );
    }else{
      return (
        <TBCBackground BG bg={Object.assign({_attributes: {
          color: '#000'
        }})}>
          <div style={{position: `absolute`, margin: 0, padding: 0, left: 0, right: 0, bottom: 0, top: 0, display: this.props.is_active ? 'block' : 'none'}} onClick={() => {
            if (global.DEBUG){
              console.log("SS");            
            }
            this.nextMessage()
          }}>/                        
          </div>
        </TBCBackground>
      );
    }
  }

}